import {Component, Injector, OnInit} from '@angular/core';
import {Log, LogTag} from '../../services/Log';
import {Observable, of, switchMap} from "rxjs";
import {delay} from "rxjs/operators";
import {ILogInfo} from "../../interfaces/ILogInfo";

@Component({
  selector: 'app-close',
  templateUrl: './close.component.html',
  styleUrls: ['../reg-dialog/reg.dialog.component.css', './close.component.css']
})
export class CloseComponent implements OnInit {
  constructor(protected  injector: Injector) {
  }

  ngOnInit() {
  }

  close(): Observable<any> {
    const logInfo = Log.getLogInfo("CloseComponent", "close", []);
    return of(close).pipe(
      delay(5000),
      switchMap( r => {
        Log.d(logInfo, LogTag.REGISTRATION, 'window.close()')
        window.close();
        return of(null);
      }),
      delay(2000)
    )
  }
}
